import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FloatingList from "./FloatingElement";
import useClickOutside from "../../hooks/Screen/useClickOutside";

export default ({ options, mode, existingOption = null }) => {
  const [selectedOption, setSelectedOption] = useState(existingOption ?? options.options[0].text);
  const [open, setOpen] = useState(false);

  const handleSelect = (value, callback) => {
    setSelectedOption(value);
    setOpen(false);

    if (callback) {
      options?.options?.forEach((option) => {
        if (option?.text === value) {
          callback(option?.data);
        }
      });
    }
  };

  const dropdownRef = useClickOutside(() => setOpen(false));

  const beforeDividerOptions = options?.options?.filter((option) => !option.afterDivider);
  const afterDividerOptions = options?.options?.filter((option) => option.afterDivider);

  return (
    <div ref={dropdownRef} className="min-w-fit relative p-1">
      {/* Dropdown Button */}
      <div
        className={`min-w-fit bg-[${options?.selectedOptionBgColor ?? "white"}] rounded-lg p-2 text-gray-700 flex items-center justify-end cursor-pointer`}
        onClick={(event) => {
          event.stopPropagation();
          setOpen((prev) => !prev);
        }}
      >
        <span className="flex items-center">
          {selectedOption}
          <span>
            <ExpandMoreIcon />
          </span>
        </span>
      </div>

      {/* Dropdown Options */}
      {open && (
        <FloatingList mode margin={0}>
          <div
            id="dropdownMenu"
            className={`min-w-[190px] py-2 px-3 bg-white border border-gray-300 rounded-lg mt-1 shadow-lg z-10 ${
              options?.isSharedPerson ? "absolute top-full -right-[108px] mt-1" : "relative"
            }`}
          >
            {beforeDividerOptions?.map((option, index) => (
              <div
                key={index}
                className="flex items-center p-2 cursor-pointer text-[#969BA9] group hover:bg-gray-100"
                onClick={(event) => {
                  event.stopPropagation();
                  handleSelect(option?.text, option?.onClick);
                }}
              >
                <span>{option?.icon}</span>
                <span className="group-hover:text-[#1D4469]">{option?.text}</span>
              </div>
            ))}

            {afterDividerOptions?.length > 0 && <hr className="my-2 border-gray-300" />}
            {afterDividerOptions?.map((option, index) => (
              <div
                key={index}
                className="flex items-center p-2 cursor-pointer text-[#969BA9] group hover:bg-gray-100"
                onClick={(event) => {
                  event.stopPropagation();
                  handleSelect(option?.text, option?.onClick);
                }}
              >
                <span>{option?.icon}</span>
                <span className="group-hover:text-[#1D4469]">{option?.text}</span>
              </div>
            ))}
          </div>
        </FloatingList>
      )}
    </div>
  );
};
